import { postFileApi } from 'api/common';
import imageCompression from 'browser-image-compression';
import { IMG_MAX_WIDTH, IMG_MAX_SIZE } from 'constants';

export const upload = async (file, params, callback) => {
    const form = new FormData();
    // const files = e.target.files[0]
    form.append('upload', file);

    // console.log("## form : ", form);

    console.log('## params ==> ', params);
    console.log('## form ==> ', form);
    console.log('## file?? ==> ', file);

    try {
        const res = await postFileApi({ ...params, data: form });
        // console.log("## res :: ", res);
        if (res) callback(res);
    } catch (err) {
        console.error(err);
    }
};

// 이미지 압축
// export const compressImg = async (files) => {
//     try {
//         const compressed = await Promise.all(
//             Array.from(files).map(async (file) => {
//                 try {
//                     const compression = await imageCompression(file, {
//                         maxSizeMB: IMG_MAX_SIZE, // 이미지 최대 사이즈 지정
//                         maxWidthOrHeight: IMG_MAX_WIDTH, // 이미지 크기 지정
//                         useWebWorker: true, // 멀티쓰레드 처리 true
//                     });
//                     // imageCompression 으로 압축하면 Blob 객체로 주기 때문에 => FileList 객체로 변환 필요
//                     const changeFileType = new File([compression], file.name, {
//                         type: compression.type,
//                         lastModified: Date.now(),
//                     });

//                     // console.log("## changed file : ", changeFileType);
//                     return changeFileType;
//                 } catch (err) {
//                     console.error(err);
//                 }
//             })
//         );

//         console.log('## compressed :: ', compressed);
//         return compressed;
//     } catch (err) {
//         console.error(err);
//     }
// };
export const compressImg = async (files) => {
    const compressedFiles = await Promise.all(
        Array.from(files).map(async (file) => {
            const compressedFile = await new Promise((resolve) => {
                const fileReader = new FileReader();
                fileReader.onload = () => {
                    const dataUrl = fileReader.result;
                    const image = new Image();
                    image.onload = () => {
                        const canvas = document.createElement('canvas');
                        const MAX_WIDTH = 600; // 해상도를 더 낮춤
                        const MAX_HEIGHT = 600; // 해상도를 더 낮춤

                        const ratio = Math.min(
                            MAX_WIDTH / image.width,
                            MAX_HEIGHT / image.height,
                            1
                        );

                        const newWidth = image.width * ratio;
                        const newHeight = image.height * ratio;
                        canvas.width = newWidth;
                        canvas.height = newHeight;

                        const canvasContext = canvas.getContext('2d');
                        if (!canvasContext) {
                            console.error('Cannot get canvas context');
                            return;
                        }

                        canvasContext.drawImage(
                            image,
                            0,
                            0,
                            newWidth,
                            newHeight
                        );

                        canvas.toBlob(
                            (blob) => {
                                if (blob) {
                                    const newFile = new File(
                                        [blob],
                                        file.name.replace(/\.[^/.]+$/, '') +
                                            '.webp',
                                        {
                                            type: 'image/webp',
                                        }
                                    );
                                    resolve(newFile);
                                } else {
                                    resolve(file); // 압축 실패 시 원본 파일 반환
                                }
                            },
                            'image/webp',
                            0.7
                        );
                    };
                    image.src = dataUrl;
                };
                fileReader.readAsDataURL(file);
            });
            return compressedFile;
        })
    );
    console.log('## 파일 변환?? ', compressedFiles);
    return compressedFiles;
};

// base64string -> File로 변환
export const base64ToFile = async (base64string, type, fileName) => {
    const byteChars = atob(base64string); // atob 함수 사용해 바이너리 데이터로 변환
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
        // 바이너리 데이터를 숫자 배열로 변환
        byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers); // 숫자 배열을 Uint8Array로 변환
    const blob = new Blob([byteArray], { type: type }); // Blob 객체 생성
    const newFile = new File([blob], fileName, { type: type }); // Blob -> File 로 변환
    return newFile;
};
